// @flow
import styled, { css } from "styled-components";
import { Link } from "react-router-dom";
import buildColor from "@fdr/static-ui/ColorPalette";

export const Container = styled.section`
  width: 100%;
  ${({ enableNewDerbyDesign }) =>
    !enableNewDerbyDesign &&
    css`
      background-color: ${buildColor("navy", "default")};
    `}
`;

export const LinksWrapper = styled.ul`
  overflow-x: auto;
  display: flex;
  flex-direction: row;
  list-style-type: none;
  ${({ enableNewDerbyDesign, bigSpace }) => {
    if (!enableNewDerbyDesign) {
      return css`
        padding: 0 0 12px;
      `;
    }

    return css`
      padding: ${bigSpace ? "16px" : "8px"} 0;
    `;
  }}

  & li:first-child {
    padding-left: 12px;
  }

  & li:last-child {
    padding-right: 12px;
  }
`;

export const QuickLink = styled(Link)`
  img {
    ${({ enableNewDerbyDesign }) =>
      enableNewDerbyDesign
        ? css`
            height: 160px;
            width: 292px;
          `
        : css`
            height: 180px;
            width: 142px;
          `};
    display: flex;
    margin: 0 4px;
    border: none;
    object-fit: cover;
    box-shadow: 0 1px 4px 0 ${buildColor("black", "100")};
  }
`;

export const ExternalQuickLink = styled.a`
  img {
    display: flex;
    margin: 0 4px;
    ${({ enableNewDerbyDesign }) =>
      enableNewDerbyDesign
        ? css`
            height: 160px;
            width: 292px;
          `
        : css`
            height: 180px;
            width: 142px;
          `};
    border: none;
    object-fit: cover;
    box-shadow: 0 1px 4px 0 ${buildColor("black", "100")};
  }
`;
